let state = {
    login: {
        phone: '',
        headimg: '',
    }
};
export default state;


// WEBPACK FOOTER //
// ./src/vuex/modules/sevenAbilityIntroduce/state.js